import formsBackendClient, { ApiDefinition } from '@/tsClient/servers/noodleQuestionnaires';
import buildPath from '../utilities/buildPath';

type ThisApi = ApiDefinition['/questionnaire-templates/{questionnaireTemplateId}/section-templates/order']['PUT'];
type Input = ThisApi['params'] & ThisApi['body'];

const reorderSectionQuestionnaire = async ({ questionnaireTemplateId, order }: Input): Promise<ThisApi['response']> => {
  const path = buildPath<ThisApi>('/questionnaire-templates/{questionnaireTemplateId}/section-templates/order', { questionnaireTemplateId });
  const response = await formsBackendClient.put(path, {order});
  return response.data;
};

export default reorderSectionQuestionnaire;
